import styled from 'styled-components';

interface ButtonProps {
  color?: string;
}

const Button = styled.button<ButtonProps>`
  width: 100%;
  padding: 19px;
  background-color: #E4DA1B;
  color: ${props => props.color || '#fff'};
  font-size: 14px;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Button;
